import { LottieIconNames } from "../../../config";

import circular_gradient from "./icons/circular_gradient.json";
import dynamic_pricing from "./icons/dynamic_pricing.json";
import scraper_agent from "./icons/scraper_agent.json";
import search_agent from "./icons/search_agent.json";
import sichero from "./icons/sichero.json";
import career from "./icons/career.json";
import arrow_down from "./icons/arrow_down.json";
import contact from "./icons/contact.json";
import blog from "./icons/blog.json";
import about_us from "./icons/about_us.json";
import products from "./icons/products.json";
import search_agent_page from "./icons/search_agent_page.json";
import coins from "./icons/coins.json";
import trolley from "./icons/trolley.json";
import dynamic_pricing_page from "./icons/dynamic_pricing_page.json";
import location from "./icons/location.json";
import circle from "./icons/circle.json";
import earth from "./icons/earth.json";
import sales_agent_page from "./icons/sales_agent_page.json";
import document from "./icons/document.json";
import layers from "./icons/layers.json";
import bar_charts from "./icons/bar_charts.json";
import privacy_policy_page from "./icons/privacy_policy_page.json";

export const icons: Record<LottieIconNames, unknown> = {
  [LottieIconNames.CIRCULAR_GRADIENT]: circular_gradient,
  [LottieIconNames.DYNAMIC_PRICING]: dynamic_pricing,
  [LottieIconNames.SCRAPER_AGENT]: scraper_agent,
  [LottieIconNames.SEARCH_AGENT]: search_agent,
  [LottieIconNames.SICHERO]: sichero,
  [LottieIconNames.CAREER]: career,
  [LottieIconNames.ARROW_DOWN]: arrow_down,
  [LottieIconNames.CONTACT]: contact,
  [LottieIconNames.BLOG]: blog,
  [LottieIconNames.ABOUT_US]: about_us,
  [LottieIconNames.PRODUCTS]: products,
  [LottieIconNames.SEARCH_AGENT_PAGE]: search_agent_page,
  [LottieIconNames.COINS]: coins,
  [LottieIconNames.TROLLEY]: trolley,
  [LottieIconNames.DYNAMIC_PRICING_PAGE]: dynamic_pricing_page,
  [LottieIconNames.LOCATION]: location,
  [LottieIconNames.CIRCLE]: circle,
  [LottieIconNames.EARTH]: earth,
  [LottieIconNames.SALES_AGENT_PAGE]: sales_agent_page,
  [LottieIconNames.DOCUMENT]: document,
  [LottieIconNames.LAYERS]: layers,
  [LottieIconNames.BAR_CHARTS]: bar_charts,
  [LottieIconNames.PRIVACY_POLICY]: privacy_policy_page,
};
